import logger from '../../services/logger';
import { cloneElement } from "react";
import React from 'react';
import { Link } from 'react-router-dom';
//import InstallButton from "./InstallButton";
//import 'bootstrap/dist/css/bootstrap.min.css'; // Importez le fichier CSS de Bootstrap
import {useNavigate } from 'react-router-dom';

import "../../css/App.css";

const Header = () => {
  logger.log("Show header");
  return (
    <div className="pt-2 mb-3 header d-block d-lg-none"> {/* Applique la classe d-block d-lg-none ou 'd-md-none' pour cacher sur les écrans de taille moyenne et supérieure */}
        <div className="mb-2 container app-container">
              <div className="mt-2 d-flex align-items-center justify-content-between">
                <div>
                  <Link to="/home">
                    <img src={process.env.PUBLIC_URL + '/icons/Logo_dcare.svg'} style={{ width: 'auto', height: '20px', verticalAlign: 'middle', cursor: 'pointer'}} alt="logo"/>
                  </Link>
                </div>  
                <div>
                  <Link to="/profile">
                    <img src={process.env.PUBLIC_URL + '/icons/Profile.svg'} style={{ width: 'auto', height: '20px', verticalAlign: 'middle', cursor: 'pointer' }} alt="profil" />
                  </Link>
                </div>
              </div>
        </div>
  </div>
  );
};

const PageTitle = ({ title, rightButton = null  }) => {
  const navigate = useNavigate();
  const handleBackClick = () => {
    // Vérifie si un iframe est présent
    const hasIframe = document.querySelector('iframe') !== null;

    if (hasIframe) {
      // Naviguer directement vers une route spécifique si un iframe est présent
      navigate(-2); // Remplacez par la route appropriée
    } else {
      // Revenir à la page précédente
      navigate(-1);
    }
  };
  return (
    <div className='mt-4 mb-4'>
      <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div onClick={handleBackClick} className="button-back">&lt;</div>
        <div className="title-container">{title}</div>
        <div className="d-none d-lg-flex" style={{ position: "absolute", right: 0 }}>
          {rightButton &&
          cloneElement(rightButton, {
            className: `${rightButton.props.className || ""} btn btn-primary btn-block`
          })}
        </div>
      </div>
      {/* Mobile : new line, center, clone button to add new bootstrap props*/}
      <div className="d-flex d-lg-none mt-3">
        {rightButton &&
          cloneElement(rightButton, {
            className: `${rightButton.props.className || ""} col-12 btn btn-primary btn-block`
          })}
      </div>
    </div>
   );
  };
  
  export { PageTitle };
export default Header;
